function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPingArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expermentation-v02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-274.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1.917591, 0, 0, 1.896153, -274.40094, -139.79985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ping-arrow-blue",
    transform: "matrix(1, 0, 0, 1, 274, 132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,18.0431575 C22.3196821,18.3775127 22.3409943,18.90576 22.0639364,19.2659674 L22,19.3404508 L17.993948,23.0819826 L28.1229314,23.082675 C28.607323,23.082675 29,23.4933753 29,23.9999998 C29,24.4749603 28.6548738,24.8656124 28.2126066,24.9125886 L28.1229314,24.9173247 L17.993948,24.9166324 L22,28.6595488 C22.3196821,28.993904 22.3409943,29.5221513 22.0639364,29.8823587 L22,29.9568421 C21.6803179,30.2911972 21.1752524,30.3134876 20.8308525,30.0237131 L20.7596378,29.9568421 L15.2568874,24.6486464 C14.9372053,24.3142913 14.9158932,23.786044 15.192951,23.4258365 L15.2568874,23.3513532 L20.7596378,18.0431575 C21.1021543,17.6849199 21.6574834,17.6849199 22,18.0431575 Z",
    id: "arrow",
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,18.0431575 C27.3196821,18.3775127 27.3409943,18.90576 27.0639364,19.2659674 L27,19.3404508 L22.993948,23.0819826 L33.1229314,23.082675 C33.607323,23.082675 34,23.4933753 34,23.9999998 C34,24.4749603 33.6548738,24.8656124 33.2126066,24.9125886 L33.1229314,24.9173247 L22.993948,24.9166324 L27,28.6595488 C27.3196821,28.993904 27.3409943,29.5221513 27.0639364,29.8823587 L27,29.9568421 C26.6803179,30.2911972 26.1752524,30.3134876 25.8308525,30.0237131 L25.7596378,29.9568421 L20.2568874,24.6486464 C19.9372053,24.3142913 19.9158932,23.786044 20.192951,23.4258365 L20.2568874,23.3513532 L25.7596378,18.0431575 C26.1021543,17.6849199 26.6574834,17.6849199 27,18.0431575 Z",
    id: "arrow",
    transform: "matrix(-1, -1.2246467991473532e-16, 1.2246467991473532e-16, -1, 54, 48)",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPingArrow);
export default __webpack_public_path__ + "static/media/ping-arrow.5966ea14888a5044497611ee8e2ee08d.svg";
export { ForwardRef as ReactComponent };